// extracted by mini-css-extract-plugin
module.exports = {"nav":"_1t5owqO","navList":"_3Jsx5eV","navItem":"_hybvCb2","navItemActive":"_1-Ofhot","arrowButton":"_1Izfn8Z","arrowButtonActive":"_UOUQkTJ"};